export const expertiseAllowedStatusFrag = `
    code
    status
    active
`;
